import { Component, OnDestroy, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-login-backdoor',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss']
})
export default class LoginCallbackComponent  implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();


  constructor(private oidcSecurityService: OidcSecurityService) {}

  ngOnInit(): void {
    // complete the OIDC authentication callback.
    // attention: forgetting to invoke checkAuth will prevent the oidc
    // redirects from processing correctly and become paused at login-callback?code=.. url
    this.oidcSecurityService.checkAuth('events').pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
